import { render } from "./TransactionNewItem.vue?vue&type=template&id=745ee9c8&scoped=true"
import script from "./TransactionNewItem.vue?vue&type=script&lang=js"
export * from "./TransactionNewItem.vue?vue&type=script&lang=js"

import "./TransactionNewItem.vue?vue&type=style&index=0&id=745ee9c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745ee9c8"]])

export default __exports__